export default {
  textContainer: {
    alignItems: 'baseline',
    gap: 8
  }
}
